import React from "react";
import BaseInput from "../../../toolkit/baseInput";

export const MaintenanceSelector = ({
  value,
  disabled,
  onChange,
  maintenances,
  size = "sm"
}) => (
  <BaseInput
    label="Plan"
    name="mantenimiento"
    type="select"
    id="mantenimiento"
    placeholder="Plan"
    value={value}
    size={size}
    disabled={disabled}
    onChange={e => {
      const value = e.target.value;
      return onChange(value);
    }}
    options={[{ value: "", label: "Sin plan" }].concat(
      maintenances
        ? maintenances.map(option => ({
            value: option.datosBasicosMantenimientoId,
            label: option.nombre
          }))
        : []
    )}
  />
);
